import {Injectable, isDevMode} from '@angular/core';
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";

import {SurveyComponent} from "@survey/components/survey/survey.component";

import {AuthenticationService} from "@shared/services/authentication/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class SurveyDisplayService {

  private readonly surveyCounterLSKey = 'survey-counter';
  private readonly surveySentDateLSKey = 'survey-sent-date';

  constructor(
    private dialog: MatDialog,
    private authenticationService: AuthenticationService) {
  }

  tryShowSurvey() {
    if (this.authenticationService.isLoggedByToken || isDevMode())
      return;

    let counter: number = +(localStorage.getItem(this.surveyCounterLSKey) ?? 0);
    counter++;

    const currentDate = new Date();
    const surveyShownDateRaw = localStorage.getItem(this.surveySentDateLSKey);
    const isFirstTimeShow = surveyShownDateRaw === null;
    const surveyShownDate = isFirstTimeShow ? currentDate : new Date(surveyShownDateRaw!);
    const whenShowSurvey = new Date(new Date().setFullYear(surveyShownDate.getFullYear() + 1));

    if (counter >= 10 && (isFirstTimeShow || currentDate.getTime() >= whenShowSurvey.getTime())) {
      counter = 0;
      this.openDialog(SurveyComponent);
    }

    localStorage.setItem(this.surveyCounterLSKey, counter.toString());
  }

  saveSurveySentDate() {
    localStorage.setItem(this.surveySentDateLSKey, new Date().toString());
  }

  private openDialog(component: any, model?: any) {
    const dialogRef = this.dialog.open(component, {
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      autoFocus: false,
      data: model,
    } as MatDialogConfig);
  }

}
